export default {
  path: "/SectionContent/VehicleDetails",
  name: "Vehicle Details",
  htmlContent: "vehicle_details.html",
  headings: [
    { id: "VehicleIdentification", text: "Vehicle Identification", type: "heading" },
    { id: "n31Year", text: "31. Year", type: "field" },
    { id: "n32Make", text: "32. Make", type: "field" },
    { id: "n33Model", text: "33. Model", type: "field" },
    { id: "n34VIN", text: "34. VIN", type: "field" },
    { id: "n35VehicleColor", text: "35. Vehicle Color", type: "field" },
    { id: "n36Tag", text: "36. Tag #", type: "field" },
    { id: "n37TrailerTag", text: "37. Trailer Tag #", type: "field" },
    { id: "VehicleRemoval", text: "Vehicle Removal", type: "heading" },
    { id: "n39RemovedBy", text: "39. Removed By", type: "field" },
    { id: "VehicleUnitDescription", text: "Vehicle/Unit Description", type: "heading" },
    { id: "n55VehicleClass", text: "55. Vehicle Class", type: "field" },
    { id: "n56VehicleUnitType", text: "56. Vehicle/Unit Type", type: "field" },
    { id: "n58NumberOfOccupants", text: "58. Number of Occupants", type: "field" },
    { id: "UnitDamage", text: "Unit Damage", type: "heading" },
    { id: "n59AreaOfInitialContact", text: "59. Area of Initial Contact ", type: "field" },
    { id: "n60DamageToVehicle", text: "60. Damage To Vehicle", type: "field" },
  ],
};
